<template>
    <div>
        <div class="d-flex align-items-center text-align justify-content-center" 
            style="height: 300px; flex-direction: column"
            v-if="loadingInitial">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <br>
            <p class="mt-2">Loading</p>
        </div>

        <form @submit.prevent="updateWebhook()" v-else>

            <button class="btn btn-danger mb-2" @click.prevent="refreshKey()">Reset Key</button>

            <div class="form-group mb-0">
                <label for="example-text-input" class="col-form-label text-left d-block">API KEY</label>
                <input type="text" class="form-control" :value="form.api_key" readonly>
            </div>

            <div class="form-group mb-0">
                <label for="example-text-input" class="col-form-label text-left d-block">SECRET KEY</label>
                <input type="text" class="form-control" :value="form.secret_key" readonly>
            </div>
            
            <div class="form-group mb-0">
                <label for="example-text-input" class="col-form-label text-left d-block">Webhook</label>
                <input type="text" class="form-control" v-model="form.webhook">
            </div>

            <button class="btn btn-success waves-effect waves-light mt-4" :disabled="loading">
                Simpan Pengaturan
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: false,
            loadingInitial: false,
            company_id: null,
            form: {
                api_key: null,
                secret_key: null,
                webhook: null,
            }
        }
    },
    methods: {
        updateWebhook() {
            this.loadingInitial = true;

            let storedData = {
                webhook_url: this.form.webhook,
            }
            
            this.$http.put(`${this.API_URL}company-setting?webhook_url=true`, storedData, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                const result = response.data;
                
                if(result.success) {
                    this.sAlert('success', "Berhasil mengupdate webhook!")
                    this.loadInitialData()
                }else {
                    this.sAlert('error', result.message)
                }
                this.loadingInitial = false;
            })
            .catch(error => {
                this.loadingInitial = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        loadInitialData() {
            this.loadingInitial = true;

            // GET COMPANY SETTING
            const companySetting = this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`
                }
            })

            Promise.all([ companySetting ])
            .then(([ responseCompany ]) => {
                const resultCompany = responseCompany.data;

                if (resultCompany.success) {
                    if(resultCompany.data){ 
                        this.form.api_key = resultCompany.data.api_key
                        this.form.secret_key = resultCompany.data.api_secret
                        this.form.webhook = resultCompany.data.webhook_url
                        this.company_id = resultCompany.data.company_id
                     }
                    this.loadingInitial = false;
                }
            })
            .catch(error => {
                console.log(error);
                this.loadingInitial = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        refreshKey() {
            Swal.fire({
            title: 'Apakah anda yakin untuk mengganti API_KEY dan SECRET_KEY anda',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Reset!'
            }).then((result) => {
                if (result.value) {
                    const companySetting = this.$http.get(`${this.API_URL}company/refresh-api-key/${this.company_id}`, {
                        headers: { 
                            'Authorization': `Bearer ${this.$cookies.get("token_instance")}`
                        }
                    }).then(res => {
                        this.loadInitialData()
                    }).catch(err => {
                        this.sAlert('error', "Error, Terjadi Kesalahan!")
                    })
                }
            })
        }
    },
    mounted() {
        this.loadInitialData()
    }
}
</script>

<style>

</style>